import React from "react";

interface RotateIconProps {
  className?: string;
}

const RotateIcon: React.FC<RotateIconProps> = ({ className = "w-4 h-4" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <mask
      id="mask0_2604_1229"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2604_1229)">
      <path
        d="M8.20648 13.8819L4.00264 9.69477C3.95298 9.64355 3.91575 9.58799 3.89098 9.5281C3.8662 9.46832 3.85381 9.4061 3.85381 9.34144C3.85381 9.2121 3.89892 9.09505 3.98914 8.99027C4.07925 8.8856 4.19992 8.83327 4.35114 8.83327C4.41836 8.83327 4.48348 8.84566 4.54648 8.87044C4.60948 8.89521 4.66575 8.93238 4.71531 8.98194L8.91914 13.1858C8.95759 13.2285 9.00675 13.2489 9.06664 13.2468C9.12653 13.2445 9.1757 13.2242 9.21414 13.1858L12.65 9.74994H11.1795C11.0378 9.74994 10.919 9.70199 10.8231 9.6061C10.7274 9.51021 10.6795 9.39143 10.6795 9.24977C10.6795 9.10799 10.7274 8.98927 10.8231 8.8936C10.919 8.79782 11.0378 8.74994 11.1795 8.74994H13.7435C13.9143 8.74994 14.0574 8.80766 14.1728 8.9231C14.2884 9.03866 14.3461 9.18177 14.3461 9.35244V11.9166C14.3461 12.0583 14.2982 12.177 14.2023 12.2728C14.1064 12.3687 13.9876 12.4166 13.846 12.4166C13.7042 12.4166 13.5854 12.3687 13.4896 12.2728C13.394 12.177 13.3461 12.0583 13.3461 11.9166V10.4461L9.91014 13.8819C9.79992 13.9919 9.67208 14.0769 9.52664 14.1369C9.38131 14.1968 9.22842 14.2268 9.06798 14.2268C8.91753 14.2268 8.76659 14.1968 8.61514 14.1369C8.46381 14.0769 8.32759 13.9919 8.20648 13.8819ZM2.25648 7.24343C2.0857 7.24343 1.94259 7.18571 1.82714 7.07027C1.71159 6.95482 1.65381 6.81171 1.65381 6.64094L1.65381 4.07693C1.65381 3.93527 1.70175 3.81649 1.79764 3.7206C1.89353 3.62482 2.01231 3.57693 2.15398 3.57693C2.29575 3.57693 2.41453 3.62482 2.51031 3.7206C2.60598 3.81649 2.65381 3.93527 2.65381 4.07693V5.54743L6.08981 2.11143C6.21047 1.99155 6.3462 1.9041 6.49697 1.8491C6.64786 1.7941 6.79875 1.7666 6.94964 1.7666C7.11053 1.7666 7.26381 1.7941 7.40947 1.8491C7.55503 1.9041 7.68303 1.99155 7.79347 2.11143L11.9973 6.2986C12.047 6.34994 12.0842 6.40549 12.109 6.46527C12.1338 6.52516 12.1461 6.58744 12.1461 6.6521C12.1461 6.78144 12.101 6.89844 12.0108 7.0031C11.9207 7.10777 11.8 7.1601 11.6488 7.1601C11.5816 7.1601 11.5165 7.14771 11.4535 7.12294C11.3905 7.09816 11.3342 7.06099 11.2846 7.01144L7.08081 2.8076C7.04236 2.76494 6.9932 2.74466 6.93331 2.74677C6.87342 2.74888 6.82425 2.76916 6.78581 2.8076L3.34998 6.2436L4.82048 6.2436C4.96214 6.2436 5.08092 6.29155 5.17681 6.38743C5.27259 6.48321 5.32048 6.60199 5.32048 6.74377C5.32048 6.88544 5.27259 7.00416 5.17681 7.09994C5.08092 7.1956 4.96214 7.24343 4.82048 7.24343L2.25648 7.24343Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export default RotateIcon;
